import createMessage from "./createMessage";
import protoRoot from "../proto-root";

const name = "audioPacket";

function create({ codec = "OPUS", data }) {
  const AudioPacket = protoRoot.lookupType(`comm.AudioPacket`);
  const CodecType = AudioPacket.lookupEnum("CodecType");

  const audioPacket = AudioPacket.create({
    codec: CodecType.values[codec],
    data,
    flush: false,
    listening: false
  });

  return createMessage({
    [name]: audioPacket
  });
}

export default {
  create,
  name
};

// enum CodecType {
//     OPUS = 0;
// }
// CodecType codec = 1;
// bool flush = 2;
// bytes data = 3;
// bool listening = 4;
